import {
  DomainAPI,
  Channel,
  APIKey,
  Authorization,
  SecretApiKey,
  SecretApiKeyExpires,
  generateKey,
} from "../utils/setting";

import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";

const customer = {
  state: {
    listCustomer: [],
    detailCustomer: {},
    detailOrderCustomer: {},
    customerInfo: {},
    imgServiceURL: "",
    errorCode: "",
    total: 0,
    count: 0,
    chart: {},
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    getChart(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/customers/chartCustomer";

      return fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1 && result.data) {
            let { gender = [], age = [], other = 0 } = result.data;
            // gender = gender.map(e => {
            //     e.count = e.customers.length
            //     return e
            // });
            result.data.gender = gender;
            this.setState({ chart: result.data });
          }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.message };
        });
    },
    async createCustomer(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/customers/createCustomer";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result && result.code) _this.setState({ imgServiceURL: "" });
          dispatch.serviceSetting.getServiceSetting(); // Cập nhât lại list service setting
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },

    async getListCustomer(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/customers/getListCustomer";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1)
            _this.setState({
              listCustomer: result.data.list,
              total: result.data.total,
              count: result.data.count,
            });
          else _this.setState({ listCustomer: [] });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async editCustomer(payload = {}, rootState) {
      let url = DomainAPI + Channel + "/api/secure/customers/editCustomer";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          // if (result.code === 1) this.getListCustomer()
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async deleteCustomer(payload, rootState) {
      const _this = this;
      let token = rootState.user.token;
      let url = DomainAPI + Channel + "/api/secure/customers/deleteCustomer";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          customerIdArray: payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          // if (result.code === 1) this.getListCustomer()
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async searchCustomer(payload, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/customers/searchCustomer";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          keyword: payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) _this.setState({ listCustomer: result.data });
          else _this.setState({ listCustomer: [] });
          return result;
        })
        .catch((error) => {
          _this.setState({ listCustomer: [] });
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateImgCustomer(payload, rootState) {
      const _this = this;
      let data = {
        url: payload.url,
        mobile: payload.mobile,
        countryCode: payload.countryCode,
      };
      let url =
        DomainAPI + Channel + "/api/secure/customers/updateAvatarCustomer";

      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          // if (result.code === 1) this.getListCustomer()
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async editAvatarCustomer(payload, rootState) {
      const _this = this;
      let data = {
        url: payload.url,
        no: payload.serviceCode,
      };
      let url = DomainAPI + Channel + "/api/secure/customer/editAvatarCustomer";

      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async detailCustomer(payload = {}, rootState) {
      const _this = this;
      let token = rootState.user.token;
      let url = DomainAPI + Channel + "/api/secure/customers/detailCustomer";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1)
            _this.setState({ detailCustomer: result.data });
          else _this.setState({ detailCustomer: {} });
          return result;
        })
        .catch((error) => {
          _this.setState({ detailCustomer: {} });
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async getDetailCustomerByDate(payload = {}, rootState) {
      const _this = this;
      let token = rootState.user.token;
      let url = DomainAPI + Channel + "/api/secure/customers/detailCustomer";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1)
            _this.setState({ detailOrderCustomer: result.data });
          else _this.setState({ detailOrderCustomer: {} });
          return result;
        })
        .catch((error) => {
          _this.setState({ detailOrderCustomer: {} });
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async findCustomer(payload = {}, rootState) {
      const _this = this;
      let token = rootState.user.token;
      let url = DomainAPI + Channel + "/api/secure/customers/findCustomer";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async getCustomerInfoById(payload = {}, rootState) {
      const _this = this;
      let token = rootState.user.token;
      let url =
        DomainAPI + Channel + "/api/secure/customers/getCustomerInfoById";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};

export default customer;
